<template>
  <div id="app">
    <navbar></navbar>
    <div id="routerView">
      <router-view :key="$route.fullPath" />
    </div>
    <div style="width:100%;text-align:center" class="mb-5">
      <h4 class="mb-3" style="color:white">Enjoying LinkedList?</h4>
      <a href="https://www.producthunt.com/posts/list-o-links?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-list-o-links" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=172775&theme=dark" alt="List O'Links - Create and Share Blockchain-based Lists of Links | Product Hunt Embed" style="width: 250px; height: 54px;" width="250px" height="54px" /></a>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import PageFooter from '@/components/PageFooter'

export default {
  components: {
    Navbar,
    PageFooter
  },
  metaInfo: {
    link: [
      {rel: 'canonical', href: 'https://listolinks.cabinetapps.com'}
    ],
    meta: [
      // OpenGraph data (Most widely used)
      {property: 'og:title', content: "List O'Links"},
      {property: 'og:site_name', content: "List O'Links"},
      {property: 'og:type', content: 'website'},
      {property: 'og:url', content: 'https://listolinks.cabinetapps.com'},
      {property: 'og:image', content: 'https://i.ibb.co/tmXgFqd/catlikeslinks.png'},
      {property: 'og:description', content: "List O'Links gives you a beautiful page to share links that you collect. The links can be blog articles, YouTube videos, Podcasts, products you want to recommend, or any other online content. "}

      // Twitter card
      // {name: 'twitter:card', content: 'summary'},
      // {name: 'twitter:site', content: 'https://www.my-site.com/my-special-page'},
      // {name: 'twitter:title', content: 'My Page Title ← My Site'},
      // {name: 'twitter:description', content: 'I have things here on my site.'},
      // // Your twitter handle, if you have one.
      // {name: 'twitter:creator', content: '@alligatorio'}
      // {name: 'twitter:image:src', content: 'https://www.my-site.com/my-special-image.jpg'},

      // // Google / Schema.org markup:
      // {itemprop: 'name', content: "List O'Links"},
      // {itemprop: 'description', content: 'I have things here on my site.'},
      // {itemprop: 'image', content: 'https://www.my-site.com/my-special-image.jpg'}
    ]
  }
}
</script>

<style lang="scss">
@import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
  color: #161616;
  // color: #c42c00;
}

#routerView {
  margin-top: 20px;
  margin-bottom: 80px;
}
</style>
